import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20dramatic%20warm%20lighting%2C%20abstract%20geometric%20shapes%20in%20deep%20amber%20and%20charcoal%20tones%2C%20cinematic%20composition%2C%20editorial%20style%2C%20soft%20spotlight%20effect%2C%20gossip%20news%20website%20hero%20background%2C%20textured%20dark%20surface%2C%20professional%20photography%2C%20mysterious%20and%20engaging%20mood&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="黑料在线 - 网红八卦资讯平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 pt-20">
        <div className="inline-flex items-center gap-2 bg-accent-500/90 text-background-50 text-xs font-medium px-4 py-1.5 rounded-full mb-6">
          <i className="ri-fire-line"></i>
          今日最新爆料已更新
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 leading-tight mb-4">
          最新网红黑料
          <br />
          每日实时更新
        </h1>
        <p className="text-sm md:text-base text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          一站式追踪全网热门爆料，涵盖网红黑料、娱乐圈八卦、直播圈内幕，吃瓜追瓜快人一步
        </p>

        <Link
          to="/category/wanghong-baoliao"
          className="inline-flex items-center gap-2 whitespace-nowrap px-7 py-3 bg-accent-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-accent-600 transition-colors cursor-pointer"
        >
          立即吃瓜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex items-end gap-4 z-10">
        <div className="w-44 h-56 rounded-xl overflow-hidden transform translate-y-6 rotate-[-3deg] opacity-80">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20portrait%20silhouette%20with%20mysterious%20warm%20backlighting%2C%20editorial%20photography%20style%2C%20dark%20atmosphere%2C%20celebrity%20scandal%20theme%2C%20soft%20golden%20rim%20light%2C%20anonymous%20figure%2C%20cinematic%20mood%2C%20deep%20amber%20and%20charcoal%20tones%2C%20professional%20composition&width=400&height=560&seq=hero-card-01&orientation=portrait"
            alt="最新爆料"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-48 h-64 rounded-xl overflow-hidden z-10 shadow-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Investigative%20journalism%20theme%20with%20dramatic%20spotlight%20on%20microphone%2C%20dark%20mysterious%20background%2C%20editorial%20photography%2C%20warm%20golden%20and%20deep%20brown%20tones%2C%20news%20breaking%20atmosphere%2C%20professional%20studio%20lighting%2C%20cinematic%20composition&width=400&height=560&seq=hero-card-02&orientation=portrait"
            alt="热门爆料"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-44 h-56 rounded-xl overflow-hidden transform translate-y-6 rotate-[3deg] opacity-80">
          <img
            src="https://readdy.ai/api/search-image?query=Social%20media%20scandal%20concept%20with%20dramatic%20red%20and%20dark%20lighting%2C%20smartphone%20screen%20glowing%20in%20darkness%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20warm%20dramatic%20tones%2C%20breaking%20news%20mood%2C%20cinematic%20composition%2C%20professional%20lighting%20setup&width=400&height=560&seq=hero-card-03&orientation=portrait"
            alt="实时更新"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}